"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _CustomOverlayLayoutWithoutFooter = _interopRequireDefault(require("./CustomOverlayLayoutWithoutFooter"));
var _ListPicker = _interopRequireDefault(require("../ListPicker"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var YearPickerOverlay = /*#__PURE__*/function (_React$Component) {
  function YearPickerOverlay(props) {
    var _this;
    (0, _classCallCheck2.default)(this, YearPickerOverlay);
    _this = _callSuper(this, YearPickerOverlay, [props]);
    _this.years = [];
    _this.handleYearClick = _this.handleYearClick.bind(_this);
    var minDate = props.minimumDate;
    if (!minDate) {
      var today = new Date();
      minDate = new Date(today.getFullYear() - 5, today.getMonth(), today.getDate()); // by default 5 years from now
    }
    var currentYear = new Date().getFullYear();
    var minimumYear = minDate.getFullYear();
    _this.years = [currentYear];

    // get years from minimum date to now
    if (!props.disablePastDays && currentYear > minimumYear) {
      _this.years = _this.years.concat(Array.from(Array(currentYear - minimumYear).keys(), function (key) {
        return key + minimumYear;
      }));
    }

    // get years from now to at least 10 years forward or as much as past years
    if (!props.disableFutureDays) {
      _this.years = _this.years.concat(Array.from(Array(Math.max(currentYear - minimumYear, 10)).keys(), function (key) {
        return key + currentYear + 1;
      }));
    }
    _this.years.sort();
    return _this;
  }
  (0, _inherits2.default)(YearPickerOverlay, _React$Component);
  return (0, _createClass2.default)(YearPickerOverlay, [{
    key: "handleYearClick",
    value: function handleYearClick(year) {
      if (this.props.onChange) {
        var date = this.props.value ? new Date(this.props.value) : new Date();
        date.setFullYear(year);
        this.props.onChange(date);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        translations = _this$props.translations,
        props = (0, _objectWithoutProperties2.default)(_this$props, ["value", "translations"]);
      return /*#__PURE__*/_react.default.createElement(_CustomOverlayLayoutWithoutFooter.default, (0, _extends2.default)({
        headerElement: translations.year
      }, props), /*#__PURE__*/_react.default.createElement(_ListPicker.default, {
        itemList: this.years,
        onItemClick: this.handleYearClick,
        selectedItem: value ? value.getFullYear() : null,
        type: "year"
      }));
    }
  }]);
}(_react.default.Component);
YearPickerOverlay.defaultProps = {
  translations: {
    year: 'Year'
  }
};
var _default = exports.default = YearPickerOverlay;